
import Random from "~/ts/library/Random";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import ConsoleWrapper from "~/ts/library/Console";
import OperatorNodeRequest from "~/operatorApplication/ts/service/comet/OperatorNodeRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {useCoreUiHtmlify, useCoreUiHtmlifyProps} from "~/core-ui/vue/ui/useCoreUiHtmlify";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {ExtractPropTypes} from "vue";
import {SNIPPET_DISPLAY_SIZE, SNIPPET_SIZE} from "~/operatorApplication/vue/misc/Snippet";


export default {
    name: "OperatorApplicationHtmlify",
    props: {
        ...useCoreUiHtmlifyProps()
    },
    setup(props: Readonly<ExtractPropTypes<ReturnType<typeof useCoreUiHtmlifyProps>>>) {

        let htmlify = useCoreUiHtmlify(props, {
            getSnippetId: function (href: string) {
                let snippetId: string = null;
                if (href.toLowerCase().indexOf("http") != -1) {
                    snippetId = Random.uid();
                    addDisposableEvent(OperatorApplicationEventManager.once(snippetId, (data: CometOperatorApplication.SnippetCometMessageOpenApiModel) => {
                        htmlify.onSnippet(href, snippetId, data, SNIPPET_DISPLAY_SIZE);
                    }, 60000));
                    requestSnippet(href, snippetId);
                }
                return snippetId;
            }
        })

        function requestSnippet(href: string, snippetId: string) {
            try {
                let body: CometOperatorApplication.CometOperatorRequestSnippetBodyOpenApiModel = {
                    channel: OperatorAccountStore.data.value.comet.channelId,
                    url: href,
                    id: snippetId,
                    size: SNIPPET_SIZE
                };
                (new OperatorNodeRequest("/requestSnippetByOperator"))
                    .setBody(body)
                    .send(false);
            } catch (e) {
                ConsoleWrapper.error("Error on snippet request");
            }
        }

        return htmlify.render;
    }
}
